
# external index without chat channel models

require('./bs_modal.js')

